import React from 'react';
import './PageFooter.css';

const PageFooter: React.FC = () => {
  return (
    <div className="page-footer">
      <span className="footer-text">© 2024 AI Agent Workflow Platform</span>
      <span className="footer-separator">•</span>
      <span className="footer-text">A Product of <strong>Xoriant</strong></span>
    </div>
  );
};

export default PageFooter;

